// @flow
import { TOGGLE_SNACKBAR } from "./types";
import type { Action } from "../actions/types";

export const showSuccessMsg = (msg: string, timeout: number = 2000): Action => ({
  type: TOGGLE_SNACKBAR,
  payload: {
    type: 'SUCCESS',
    msg,
    open: true,
    timeout,
  }
});

export const showErrorMsg = (msg: string, timeout: number = 2000): Action => ({
  type: TOGGLE_SNACKBAR,
  payload: {
    type: 'ERROR',
    open: true,
    msg,
    timeout,
  }
});

export const closeSnackBar = (): Action => ({
  type: TOGGLE_SNACKBAR,
  payload: {
    open: false,
  }
});